module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-sidenav', {
    ref: "collaboratorsNav",
    staticClass: "md-left collaboratorsNav"
  }, [_c('md-toolbar', {
    staticClass: "md-dense main-toolbar"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        return _vm.back()
      }
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('h3', {
    staticClass: "md-title"
  }, [_vm._v("Collaborators")])], 1), _vm._v(" "), _c('md-list', {
    staticClass: "md-double-line"
  }, [_c('md-subheader', [_vm._v("Current Collaborators")]), _vm._v(" "), (_vm.owner) ? _c('md-list-item', [_c('md-avatar', [(_vm.owner.profile_picture) ? _c('img', {
    attrs: {
      "src": _vm.owner.profile_picture,
      "alt": "People"
    }
  }) : _c('img', {
    attrs: {
      "src": require('../../assets/img/silhouette.jpg'),
      "alt": "People"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "md-list-text-container collaborator-text-container"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.owner.username))])]), _vm._v(" "), _c('div', [(!_vm.isAdministrator) ? _c('span', {
    staticClass: "role-text-edit"
  }, [_vm._v(_vm._s(_vm.project.ownerRole))]) : _c('span', {
    staticClass: "role-text-edit",
    attrs: {
      "contenteditable": ""
    },
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.cancelEdit.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "left", 37, $event.key, ["Left", "ArrowLeft"])) { return null; }
        if ('button' in $event && $event.button !== 0) { return null; }
        return _vm.ignoreKeydown.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "right", 39, $event.key, ["Right", "ArrowRight"])) { return null; }
        if ('button' in $event && $event.button !== 2) { return null; }
        return _vm.ignoreKeydown.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.saveEdit(_vm.owner.uid, $event)
      }],
      "blur": function($event) {
        return _vm.stopEdit(_vm.owner.uid, $event)
      }
    }
  }, [_vm._v(_vm._s(_vm.project.ownerRole))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("(Project Owner)")])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.owner.email))])])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.subCollaborators), function(collab) {
    return (_vm.subCollaborators.length > 0) ? _c('collaborator', {
      key: collab.uid,
      attrs: {
        "user": _vm.user,
        "collabUser": _vm.collabUsers[collab.uid],
        "collaborator": collab,
        "editable": _vm.isAdministrator,
        "layers": _vm.layers
      },
      on: {
        "removeCollaborator": _vm.removeCollaborator,
        "openCollaboratorAccessModal": _vm.openCollaboratorAccessModal,
        "close": _vm.emitClose
      }
    }) : _vm._e()
  })], 2), _vm._v(" "), _c('md-list', {
    staticClass: "md-double-line pendingCollaboratorList"
  }, [_c('md-subheader', [_vm._v("Pending Collaborators")]), _vm._v(" "), _vm._l((_vm.pendingCollaborators), function(collab) {
    return (_vm.pendingCollaborators.length > 0) ? _c('pendingCollaborator', {
      key: collab.id,
      attrs: {
        "collaborator": collab,
        "editable": _vm.user.uid === _vm.owner.uid
      },
      on: {
        "removePendingCollaborator": _vm.removePendingCollaborator,
        "resendInvitation": _vm.resendInvitation
      }
    }) : _vm._e()
  })], 2), _vm._v(" "), _c('md-list', [(_vm.canEdit) ? _c('invite', {
    attrs: {
      "project": _vm.project
    },
    on: {
      "addCollaborator": _vm.addCollaborator
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "change-collaborator-access",
    staticClass: "collaborator-access-modal",
    on: {
      "open": _vm.onCollaboratorAccessModalOpen,
      "close": _vm.onCollaboratorAccessModalClose
    }
  }, [_c('md-dialog-title', [_vm._v("Collaborator Access")]), _vm._v(" "), (_vm.collaborator) ? _c('md-dialog-content', {
    staticStyle: {
      "display": "flex"
    }
  }, [(_vm.isLoadingUserInfo) ? _c('div', {
    staticClass: "loading-state"
  }, [_c('md-spinner', {
    attrs: {
      "md-size": 60,
      "md-indeterminate": ""
    }
  })], 1) : (_vm.collaborator.userInfo) ? _c('div', {
    staticClass: "collaborator-access-options-content"
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': !_vm.collaborator.role
    }
  }, [_c('label', {
    attrs: {
      "for": "collaborator-role"
    }
  }, [_vm._v("Role")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "collaborator-role",
      "required": "",
      "disabled": !_vm.isAdministrator && (_vm.collaborator.uid !== _vm.user.uid)
    },
    model: {
      value: (_vm.collaborator.role),
      callback: function($$v) {
        _vm.$set(_vm.collaborator, "role", $$v)
      },
      expression: "collaborator.role"
    }
  })], 1), _vm._v(" "), (_vm.restriction.restricted) ? _c('div', {
    staticClass: "observer-access-note"
  }, [_c('p', [_vm._v(_vm._s(_vm.observerText))]), _vm._v(" "), (_vm.restriction.inactiveAdmin) ? _c('p', [_vm._v(_vm._s(_vm.inactiveAdminNote))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "collaborator-access-options"
  }, [_c('p', [_vm._v("Change the collaborator access for "), _c('strong', [_vm._v(_vm._s(_vm.collaborator.name))]), (_vm.restriction.restricted) ? _c('span', {
    staticClass: "observer-tag"
  }, [_vm._v(" (Observer)")]) : _vm._e(), _vm._v(" on this project")]), _vm._v(" "), (_vm.options.showObserver) ? _c('div', {
    staticClass: "collaborator-access-option observer-option"
  }, [_c('md-radio', {
    attrs: {
      "mdValue": "observer",
      "disabled": ""
    },
    model: {
      value: (_vm.displayedType),
      callback: function($$v) {
        _vm.displayedType = $$v
      },
      expression: "displayedType"
    }
  }, [_vm._v("Observer")]), _vm._v(" "), _c('p', [_vm._v("Can view this production, but cannot edit it.")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "collaborator-access-option"
  }, [_c('md-radio', {
    attrs: {
      "mdValue": "member",
      "disabled": _vm.options.disabled.member
    },
    model: {
      value: (_vm.displayedType),
      callback: function($$v) {
        _vm.displayedType = $$v
      },
      expression: "displayedType"
    }
  }, [_vm._v("Member")]), _vm._v(" "), _c('p', [_vm._v("Can create layers and notes, but cannot alter the script; delete history snapshots; change collaborator access or remove collaborators.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "collaborator-access-option"
  }, [_c('md-radio', {
    attrs: {
      "mdValue": "administrator",
      "disabled": _vm.options.disabled.administrator
    },
    model: {
      value: (_vm.displayedType),
      callback: function($$v) {
        _vm.displayedType = $$v
      },
      expression: "displayedType"
    }
  }, [_vm._v("Administrator")]), _vm._v(" "), _c('p', [_vm._v("Has full access to the entire project, but cannot delete the project.")])], 1), _vm._v(" "), (_vm.isOwner) ? _c('div', {
    staticClass: "collaborator-access-option"
  }, [_c('md-radio', {
    attrs: {
      "mdValue": "transfer",
      "disabled": _vm.options.disabled.transfer
    },
    model: {
      value: (_vm.displayedType),
      callback: function($$v) {
        _vm.displayedType = $$v
      },
      expression: "displayedType"
    }
  }, [_vm._v("Transfer Ownership")]), _vm._v(" "), _c('p', [_vm._v("Collaborator will become the new owner of this project and will have full access to this project. You will be immediately downgraded to an Administrator and you will lose the ability to delete the project.")])], 1) : _vm._e(), _vm._v(" "), (_vm.collaboratorType === 'member') ? _c('div', {
    staticClass: "collaborator-access-option collaborator-structure-permission"
  }, [_c('md-checkbox', {
    attrs: {
      "disabled": _vm.options.disabled.structure,
      "id": "collaborator-can-edit-structure"
    },
    model: {
      value: (_vm.canEditStructure),
      callback: function($$v) {
        _vm.canEditStructure = $$v
      },
      expression: "canEditStructure"
    }
  }, [_vm._v("\n                            Can edit Structure\n                        ")]), _vm._v(" "), _c('p', [_vm._v("Allow this member to place and manage Act / Scene / Song structure markers. Administrators and project owners always have this permission.")])], 1) : (_vm.collaboratorType === 'administrator') ? _c('div', {
    staticClass: "collaborator-access-option collaborator-structure-permission structure-always"
  }, [_c('md-checkbox', {
    attrs: {
      "disabled": "",
      "id": "collaborator-can-edit-structure-admin"
    },
    model: {
      value: (_vm.adminStructureAlways),
      callback: function($$v) {
        _vm.adminStructureAlways = $$v
      },
      expression: "adminStructureAlways"
    }
  }, [_vm._v("\n                            Can edit Structure\n                        ")]), _vm._v(" "), _c('p', [_vm._v("Administrators always have Structure edit access.")])], 1) : _vm._e()])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-raised",
    attrs: {
      "disabled": !_vm.isAdministrator && !_vm.isCollaboratorOwner
    },
    on: {
      "click": _vm.action_remove_collaborator
    }
  }, [_vm._v("Remove Collaborator")]), _vm._v(" "), (_vm.collaborator && _vm.collaborator.userInfo) ? _c('md-button', {
    staticClass: "md-raised",
    attrs: {
      "disabled": !_vm.isAdministrator
    },
    on: {
      "click": _vm.action_save_changes
    }
  }, [_vm._v("Change Access")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "confirm-remove-collaborator-modal",
    attrs: {
      "md-title": 'Remove Collaborator',
      "md-content-html": 'Do you really want to remove this collaborator from project?',
      "md-ok-text": 'Yes',
      "md-cancel-text": 'No'
    },
    on: {
      "close": _vm.confirm_remove_collaborator_action
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61beb198","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collaborators/nav.vue
// module id = 1251
// module chunks = 21